export default __webpack_public_path__ + "static/media/tartaglia.d873db08.png";